export default __webpack_public_path__ + "static/media/error.eb4a4e90.png";